import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import CVView from '../views/CVView.vue';
import PortfolioView from '../views/PortfolioView.vue';
import AdminView from '../views/AdminView.vue';

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
        meta: {
            title: 'Accueil'
        }
    },
    {
        path: '/cv',
        name: 'cv',
        component: CVView,
        meta: {
            title: 'CV'
        }
    },
    {
        path: '/portfolio',
        name: 'portfolio',
        component: PortfolioView,
        meta: {
            title: 'Portfolio'
        }
    },
    {
        path: '/admin',
        name: 'admin',
        component: AdminView,
        meta: {
            title: 'Admin'
        }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    const defaultTitle = 'Arthur KEUSCH';
    document.title = to.meta.title || defaultTitle;
    next();
})

/*
mounted() {
    document.title = "Titre spécifique à ce composant";
  }
 */

export default router
